import React, { Component } from 'react';
import classNames from 'classnames';
import FontAwesome from 'react-fontawesome'

class GridSelect extends Component {

	constructor(props) {
		super(props);
		this.state = {'selected': '0'};
		this.onChange = props.onChange;
	}

	ItemSelect = (e) => {
		// console.log('select', e.target.getAttribute('data-index'), e.target.getAttribute('data-value'))
		this.setState({'selected': e.target.getAttribute('data-index')});
		this.onChange(e.target.getAttribute('data-value'));
	}

	OptionItem = (props) => {

		let itemClass = classNames({
		  'gridSelectItem': true,
		  'selected': this.state.selected === props.index.toString()
		});

		let itemStyle = {};

		if (props.item.type === 'image') {
			itemStyle.backgroundImage = 'url(' + props.item['secure_url'] + ')';
		}

		if (props.item.type === 'color') {
			itemStyle.backgroundColor = props.item.color;
		}

		return <li 
			key={props.index}
			className={itemClass}
			style={itemStyle}
			data-value={props.id}
			data-index={props.index.toString()}
			onClick={props.click}>
			{(props.item.type === 'icon') && <FontAwesome name={props.item.icon} />}
		</li> 
	  
	}

	SelectOptions = (props) => {

	  const items = props.items;
	  const click = props.itemSelect;

	  let optionItems = items.map((item, index) => this.OptionItem({id:item.id, index:index, item:item, click:click}))

	  let listClass = classNames({
      'GridSelect': true,
      'size-large': props.size === 'large',
      'size-medium': props.size === 'medium',
      'size-small': props.size === 'small'
    });

	  return (
      <ul className={listClass} name={props.name} onChange={props.onChange}>
        {optionItems}
      </ul>
    )
	
	}

  render() {

  	let wrapClass = classNames({
  		'control-wrap': true,
  		'grid-select': true,
  		'do-half': this.props.doHalf
  	})

    return (
    <div className={wrapClass}>
        <span className="control-label">{this.props.name}</span>
        { this.SelectOptions({ name: this.props.name, items: this.props.items, size: this.props.size || "large", itemSelect: this.ItemSelect}) }
    </div>
    )
  }
	
}

export default GridSelect;


// WEBPACK FOOTER //
// ./src/controls/GridSelect.jsx